var DOMPurify = require('dompurify');
class UserMessageCtrl {
  constructor($scope, $timeout, $uibModal, $sce) {
    'ngInject';
    Object.assign(this, { $scope, $timeout, $uibModal });
    this.modal;

    const wMsgs = $scope.$watchCollection("$ctrl.messages", (newVal, oldVal) => {
      if(newVal && newVal.length){
        newVal.forEach(msg => {
          if (msg.keyClass === undefined) msg.keyClass = this.getKeyClass(msg);
        });
        let newItem = newVal[newVal.length-1];
        if (!newItem.timestamp) newItem.timestamp = Date.now();
        newItem.sanitized = $sce.trustAsHtml(newItem.message);
        switch(newItem.type) {
          case undefined:
            newItem.type = 'inline';
            this.closeInSeconds(newItem);
            break;
          case 'modal':
            this.showModal(newItem);
            break;
        }
      }
    });
    $scope.$on('$destroy', () => { wMsgs() });
  }

  closeInSeconds(message){
    if(!message.closeInSeconds) return;
    const ms = message.closeInSeconds * 1000;
    this.$timeout(() => this.closeMessage(this.messages, message), ms);
  }

  closeMessage(messages, msg){
    const idx = messages.indexOf(msg);
    messages.splice(idx, 1);
  }

  getKeyClass(msg) {
    if (!msg || !msg.key) return '';
    return `user-message-key-${String(msg.key)}`;
  }

  showModal(msg){
    if (!msg.displayed) {
      msg.displayed = true;
      this.modal = this.$uibModal.open({
        template: `
          <div class="user-message">
            <button type="button" class="close" ng-click="$ctrl.closeModal()" aria-hidden="true">&times;</button>
            <div class="message">${DOMPurify.sanitize(msg.message, { USE_PROFILES: { html: true } })}</div>
          </div>`,
        scope: this.$scope,
        backdrop: 'static',
        size: 'lg'
      });
      this.modal.result.then( 
        closed => true
      );
      if (msg.closeInSeconds) {
        const ms = msg.closeInSeconds * 1000;
        this.$timeout(() => this.modal.close(), ms);
      }
    }
  }

  closeModal() {
    this.modal.close();
  }
  
}

export default {
  bindings: {
    messages: "="
  },
  templateUrl: "form-builder/utilities/user-message/user-message.component.html",
  controller: UserMessageCtrl
}
